<!-- ADD-MODAL-STRUCTURE -->
<div class="master-modal" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <!-- Modal-Header -->
        <div class="modal_close_btn">
          <span (click)="close()" class="modal-close"><i class="material-icons">close</i></span>
        </div>
        <!-- Modal content-->
        <div mat-dialog-content> 
          <!-- Modal-Body -->
          <div class="modal-body br-8">
     
            <div class="profile_complition_details">
            <!--  <div class="status_img">
                <img src="../../../../../assets/images/profile_complition.jpg" alt="">
              </div> -->
              <div class="status_content">
           <h2>Access Denied</h2>
  <p style="padding: 0;">{{ data.message }}</p>
 

                <div fxLayout="column" fxLayoutAlign="center center" style="flex-direction: column; box-sizing: border-box; display: flex; place-content: center; align-items: center;">
                  <!-- <button class="btn btn-sm global-btn" (click)="dialogClose()" mat-button [routerLink]="['/sign-up',data?.present_subscription_id,data?.id]">Continue</button> -->
                  <!-- <button class="btn btn-sm global-btn" (click)="dialogClose()" mat-button [routerLink]="['/sign-up',data?.present_subscription_id,data?.id]">Continue</button> -->
                  <button class="btn btn-sm global-btn"  (click)="onContinue()"  mat-button>Continue</button> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>




